// contacts create
import { z } from './utils/zod.js';
import { deleteResponse, dataResponse, listResponse } from './utils/response-templates.js';
// This must be in sync with the Prisma Schema
export const contactDtoSchema = z.object({
    id: z.string(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    organizationId: z.string(),
    name: z.string(),
    email: z.string(),
    phone: z
        .object({
        number: z.string(),
        countryCode: z.string().optional(),
        formattedNumber: z.string(),
    })
        .optional(),
});
export const createContactDtoSchema = z.object({
    name: z.string().trim().min(1).max(150),
    email: z.string().commonEmail(),
    phone: z.string().phoneNumber('Invalid phone number', { emptyStringAllowed: true }).optional(),
});
export const createContactListDtoSchema = z.array(createContactDtoSchema);
export const createContactResponseSchema = dataResponse(contactDtoSchema);
export const createContactListResponseSchema = listResponse(contactDtoSchema).extend({
    skipped: z.array(z.string()),
});
export const updateContactRequestSchema = createContactDtoSchema.partial();
export const updateContactResponseSchema = dataResponse(contactDtoSchema);
export const listContactsDtoSchema = contactDtoSchema.extend({});
export const listContactsResponseSchema = listResponse(listContactsDtoSchema);
export const getContactResponseSchema = dataResponse(contactDtoSchema);
export const deleteContactResponseSchema = deleteResponse();
